import { cva, sva } from "@agapi/ui/panda/css";

export const cartStepStyles = sva({
  slots: ['root', 'summary', 'summaryRow', 'summaryRowEmphasized'],
  base: {
    root: {
      display: 'flex',
      flexDir: { base: 'column', md: 'row' },
      gap: 'normal',
      p: 'none',
      justifyContent: 'space-between',
      position: 'relative'
    },
    summary: {
      display: 'flex',
      position: 'sticky',
      flexDirection: 'column',
      top: '200px',
      gap: 'tight',
      width: '100%'
    },
    summaryRow: {
      lineHeight: 'none'
    },
    summaryRowEmphasized: {
      fontWeight: 'bold',
      fontSize: 'lg',
      lineHeight: 'none'
    }
  }
})